import styled, { css } from 'styled-components';
import { layout } from 'src/components/base';

export const List = styled.ul(
  props => css`
    display: flex;
    flex-wrap: wrap;
    list-style: none;
    margin: 0;
    color: ${props.theme.text.secondary};
  `
);

export const Content = styled.span``;

export const Item = styled.li`
  &:not(:last-child)::after {
    content: '•';
    padding: ${layout.measurements.spacing050};
  }
`;
